const $inject = ['moment', '$filter'];

const sectorService = function sectorService(moment, $filter) {
  return {
    reorder: reorder,
    abridge: abridge,
    priceSummary: priceSummary,
    currentStatus: currentStatus
  };

  function reorder(obj) {

    let allSectors = [].concat(obj.Flights, obj.Rails, obj.Hotels, obj.Cars);
    let sectorTypeOrder = ['flight', 'rail', 'hotel', 'car'];

    angular.forEach(allSectors, function (sector) {
      if (sector.Carrier) {
        sector.sectorType = sectorTypeOrder[0];
        sector.date = sector.Departure.Date;
      }

      if (sector.RailNumber) {
        sector.sectorType = sectorTypeOrder[1];
        sector.date = sector.Departure.Date;
      }

      if (sector.HotelCode) {
        sector.sectorType = sectorTypeOrder[2];
        sector.date = sector.DateFrom;
      }

      if (sector.PickUp) {
        sector.sectorType = sectorTypeOrder[3];
        sector.date = sector.PickUp.Date;
      }
    });

    allSectors.sort(function (x, y) {
      let n = moment(x.date, 'YYYY-MM-DD').format('YYYYMMDD') - moment(y.date, 'YYYY-MM-DD').format('YYYYMMDD');

      return n !== 0 ? n : sectorTypeOrder.indexOf(x.sectorType) - sectorTypeOrder.indexOf(y.sectorType);
    });

    return allSectors;
  }

  function abridge(sectors) {

    const DATE_FORMAT_LONG = $filter('translate')('dates.DateFormatLong');

    let trip = {
      travelType: '',
      flights: []
    };

    let hotels = [];
    let cars = [];
    let land = [];
    let start;
    let end;

    angular.forEach(sectors, function (sector) {

      let location = {};

      if (sector.sectorType === 'flight' || sector.sectorType === 'rail') {
        location.startLocation = sector.Departure.Code;
        location.endLocation = sector.Arrival.Code;
        location.startDate = sector.Departure.Date;
        location.endDate = sector.Arrival.Date;

        trip.flights.push(location);
      }

      if (sector.sectorType === 'hotel') {
        location.startLocation = sector.Location.Code;
        location.endLocation = sector.Location.Code;
        location.startDate = sector.DateFrom;
        location.endDate = sector.DateTo;

        hotels.push(location);
        land.push(location);
      }

      if (sector.sectorType === 'car') {
        location.startLocation = sector.PickUp.Code;
        location.endLocation = sector.DropOff.Code;
        location.startDate = sector.PickUp.Date;
        location.endDate = sector.DropOff.Date;

        cars.push(location);
        land.push(location);
      }
    });


    if (trip.flights.length === 1) {
      trip.travelType = 'oneway';

      start = trip.flights[0].startDate;
      end = trip.flights[0].endDate;
    }

    else if (trip.flights.length === 2 && trip.flights[0].startLocation === trip.flights[trip.flights.length - 1].endLocation) {
      trip.travelType = 'return';

      start = trip.flights[0].startDate;
      end = trip.flights[1].endDate;
    }

    else if (trip.flights.length > 1) {
      trip.travelType = 'multi';

      start = trip.flights[0].startDate;
      end = trip.flights[trip.flights.length - 1].endDate;
    }

    else {
      if (hotels.length && cars.length) {
        trip.travelType = 'land';

        start = land[0].startDate;
        end = land[land.length - 1].endDate;
      }

      else if (hotels.length) {
        trip.travelType = 'hotel';

        start = hotels[0].startDate;
        end = hotels[hotels.length - 1].endDate;
      }

      else if (cars.length) {
        trip.travelType = 'car';

        start = cars[0].startDate;
        end = cars[cars.length - 1].endDate;
      }
    }


    if (start && end) {
      let startMoment = moment(start, 'YYYY-MM-DD').startOf('day');
      let endMoment = moment(end, 'YYYY-MM-DD').startOf('day');

      trip.length = endMoment.diff(startMoment, 'days');
      trip.startDate = startMoment.format(DATE_FORMAT_LONG);
      trip.endDate = endMoment.format(DATE_FORMAT_LONG);
    }

    trip.title = tripTitle(trip);

    return trip;
  }

  function priceSummary(sectors, config) {

    const priceTotals = {
      Flight: [],
      Rail: [],
      Hotel: [],
      Car: [],
      Seat: [],
      flights: 0,
      rails: 0,
      hotels: 0,
      cars: 0,
      combined: 0,
      lostSavings: 0
    };

    _.forEach(config.PaymentMethod.PaymentItems, paymentMethod => {
      paymentMethod = buildPaymentMethodTitle(paymentMethod, sectors);

      if (paymentMethod.Invoice) {
        paymentMethod.Invoice.titleArray = paymentMethod.sectorTitlesArray;
        priceTotals[paymentMethod.Type].push(paymentMethod.Invoice);
      } else {
        paymentMethod.Card.titleArray = paymentMethod.sectorTitlesArray;
        priceTotals[paymentMethod.Type].push(paymentMethod.Card);
      }
    });

    angular.forEach(sectors, function (sector) {
      priceTotals.lostSavings += sector.LostSavingsAmount;

      if (sector.sectorType === 'flight') {
        priceTotals.flights += sector.TotalAmount;
      }

      if (sector.sectorType === 'rail') {
        priceTotals.rails += sector.TotalAmount;
      }

      if (sector.sectorType === 'hotel') {
        priceTotals.hotels += sector.TotalAmount;
      }

      if (sector.sectorType === 'car') {
        priceTotals.cars += sector.TotalAmount;
      }
    });

    priceTotals.combined = priceTotals.flights + priceTotals.rails + priceTotals.hotels + priceTotals.cars;

    return priceTotals;
  }

  function currentStatus(passenger) {
    let approvalStates = {
      Auto: {
        id: 'AU',
        message: 'Auto approval',
        class: 'approvalApproved'
      },
      Pending: {
        id: 'AW',
        message: 'Awaiting approval',
        class: 'approvalPending'
      },
      Approved: {
        id: 'AP',
        message: 'Approved',
        class: 'approvalApproved'
      },
      Declined: {
        id: 'DN',
        message: 'Denied',
        class: 'approvalDenied'
      },
      Expired: {
        id: 'EX',
        message: 'Expired',
        class: 'approvalExpired'
      }
    };

    return approvalStates[passenger.ApprovalState];
  }

  function tripTitle(trip) {
    switch (trip.travelType) {
      case 'oneway':
        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
        break;
      case 'return':
        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
        break;
      case 'multi':
        return _.join(_.map(trip.flights, 'startLocation'), ' > ');
        break;
      case 'land':
        return 'Hotel and Car Booking';
        break;
      case 'hotel':
        return 'Hotel booking';
        break;
      case 'car':
        return 'Car booking';
        break;
      default:
        return 'Lightning booking';
    }
  }


  function buildPaymentMethodTitle(paymentMethod, sectors) {
    const grpId = paymentMethod.SectorGroupIdentifier;

    paymentMethod.sectorTitlesArray = [];

    _.forEach(sectors, sector => {

      if (sector.GroupIdentifier === grpId && sector.sectorType === 'flight') {
        paymentMethod.sectorTitlesArray.push(sector.Carrier + ' ' + sector.FlightNumber)
      }

    });

    return paymentMethod;

  }
};


sectorService.$inject = $inject;

export default sectorService;



// WEBPACK FOOTER //
// ./src/services/sectorService.js